import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { sectors } from './data';
import { PaystackButton } from 'react-paystack';
import BgImage from "../../images/practiceArea/agreement.jpeg";

const SectorDetails = () => {
  const { industryId } = useParams();
  const navigate = useNavigate();
  const sector = sectors.find(sector => sector?.category?.toLowerCase().replace(/\s+/g, '-') === industryId);
  console.log("sector", sector);
  console.log("industryId", industryId);

  useEffect(() => {
    if (sectors?.length > 0) {
      if (!industryId || !sectors?.some(sector => sector?.category?.toLowerCase().replace(/\s+/g, '-') === industryId)) {
        navigate("/industries");
      }
    }
  }, [industryId, navigate]);

  const publicKey = "pk_test_043a090c91a3279a4eaff9f6efc3fcd274ada0a7";
  const [email, setEmail] = useState("");
  const amount = 100000;
  const [mobileNumber, setMobileNumber] = useState("");
  const [city, setCity] = useState("");

  const isFormFilled = email && mobileNumber && city;

  const componentProps = {
    email,
    amount: amount * 100,
    metadata: {
      email,
      mobileNumber,
      city
    },
    publicKey,
    text: "Talk to our expert",
    onSuccess: () => alert("Payment successful"),
    onClose: () => alert("Payment closed"),
  };

  const handlePayment = () => {
    if (!isFormFilled) {
      alert("Please fill in all fields before proceeding.");
    }
  };


  return (
    <div className="workSans">
      <section
        className="relative h-[400px] md:h-[450px] flex items-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(5, 33, 55, 0.9), rgba(5, 33, 55, 0.9)), url(${BgImage})`,
        }}
      >
        <div className="container mx-auto px-6 text-white">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{sector?.category}</h1>

          <div className="flex flex-wrap items-center text-sm md:text-base space-x-2 mb-6">
            <Link to="/" className="text-blue-300 hover:underline">
              Home
            </Link>
            <span className="text-[#d11c1c] font-bold">»</span>
            <Link to="/industries" className="text-blue-300 hover:underline">
              Industries
            </Link>
            <span className="text-[#d11c1c] font-bold">»</span>
            <span className="text-white">{sector?.category}</span>
          </div>

          <hr className="border-t border-white opacity-10 mb-6" />
          <p className="text-lg md:text-l mb-6 text-white">
            {sector?.item[0]?.title}
          </p>
          {/* <p className="text-lg md:text-l mb-6 text-white">
            {sector.item[0].desc1}
          </p> */}

          <Link
            to="/book"
            className="inline-block bg-[#d11c1c] text-white text-xs md:text-sm font-semibold tracking-wide uppercase py-3 px-6 rounded-sm shadow hover:bg-[#b81616] transition"
          >
            Speak with a Senior Legal Consultant →
          </Link>
        </div>
      </section>
      <div className="md:flex justify-between items-start gap-4 px-[6%] md:px-[10%] my-[6%]">
        <div className="">
          <p className="text-lg font-[600] text-black">{sector?.item[0]?.title}</p>
          <p className="text-md text-black pb-4">{sector?.item[0]?.paragraph}</p>
          <p className="text-md text-black pb-4">{sector?.item[0]?.paragraph2}</p>
          <p className="text-md text-black pb-4">{sector?.item[0]?.paragraph3}</p>
          <p className="text-md text-black pb-4">{sector?.item[0]?.paragraph4}</p>
          {sector?.item[0]?.details?.map((item, index) => (
            <div key={index}>
              {item.heading && (
                <p className="pt-6 text-[20px] font-[600]">{item.heading}</p>
              )}
              {item.desc && (
                <p className="text-[15px]">{item.desc}</p>
              )}

              {Array.from({ length: 22 }, (_, i) => {
                const listKey = `list${i + 1}`;
                const listValue = item[listKey];

                if (!listValue) return null;

                const hasCheckEmoji = listValue.includes("✅");
                return (
                  <p
                    key={listKey}
                    className={`pt-4 pl-3 text-[15px] ${hasCheckEmoji ? "font-bold pl-0" : ""}`}
                  >
                    {hasCheckEmoji ? listValue : `- ${listValue}`}
                  </p>
                );
              })}
              {item.desc2 && (
                <p className="text-[15px] py-4">{item.desc2}</p>
              )}
            </div>
          ))}
          <p className="text-[25px] font-extrabold py-6">💼 Why Work With Lawberon Legals?</p>
          {sector?.item[0]?.workWithUs?.map((item, index) => (
            <p className="text-[15px] pt-4 pl-3" key={index}>{item.list}</p>
          ))}
        </div>
        <div className="w-full md:sticky md:top-0">
          <div className="p-4 bg-white shadow-md rounded-md">
            <p className="font-extrabold text-[20px] text-center py-2">Consult an expert today!</p>
            <div className="my-2">
              <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-gray-300 rounded-lg p-3 mt-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
              <input type="tel" placeholder="Mobile Number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} className="w-full border border-gray-300 rounded-lg p-3 mt-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
              <input type="text" placeholder="City/Pincode" value={city} onChange={(e) => setCity(e.target.value)} className="w-full border border-gray-300 rounded-lg p-3 mt-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
              {isFormFilled ? (
                <PaystackButton className="w-full bg-blue-600 text-white p-3 rounded-lg mt-3 cursor-pointer" {...componentProps} />
              ) : (
                <button onClick={handlePayment} className="w-full bg-gray-400 text-white p-3 rounded-lg mt-3 cursor-not-allowed">
                  Talk to our expert
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectorDetails;
